/// <amd-module name="Analytics/Shared/TrendChart/Common/ConfigurationUtility" />
import { IFilterItem, ITrendChartReportConfiguration } from "Analytics/Shared/TrendChart/Common/Types";

export class ConfigurationUtility {
    private static _shallowEquals(arrayA?: IFilterItem[], arrayB?: IFilterItem[]): boolean {
        if (arrayA === arrayB) {
            return true;
        }

        if (arrayA == null || arrayB == null || arrayA.length !== arrayB.length) {
            return false;
        }

        for (let i = 0, len = arrayA.length; i < len; ++i) {
            if (arrayA[i].id !== arrayB[i].id) {
                return false;
            }
        }

        return true;
    }

    public static areConfValuesEqual(
        confValues1: ITrendChartReportConfiguration | undefined,
        confValues2: ITrendChartReportConfiguration | undefined
    ): boolean {
        if (!confValues1 && !confValues2) {
            return true;
        }

        if (!confValues1 || !confValues2) {
            return false;
        }

        if (confValues1.trendBy !== confValues2.trendBy) {
            return false;
        }

        if (confValues1.period !== confValues2.period) {
            return false;
        }

        if (!ConfigurationUtility._shallowEquals(confValues1.branchItems, confValues2.branchItems)) {
            return false;
        }

        return true;
    }
}
